import React from 'react'
import { I18n } from '@front/volcanion'

import { TableCell } from '@mui/material'
import TextHeader from '@abra/elements/table/headers/Text'

const Header = props => <>
  <TableCell align='center'>
    <TextHeader label={I18n.t('companyservice.code')} icon={'room_service'} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('name.label', { count: 1 })} icon={'person'} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('password.label', { count: 1 })} icon={'security'} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('email.label', { count: 1 })} icon={'alternate_email'} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('status.label', { count: 1 })} />
  </TableCell>
</>

export default React.memo(Header)
